import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface LayoutLinkProps {
	layout: string
}

export function LayoutLink(props: LayoutLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('layouts', `${props.layout}`)
		}}>
			{props.layout}
		</a>
	)
}
